import React, { useEffect, useRef } from "react";
import BackArrow from "./BackArrow";
import { useLocation, useNavigate } from "react-router-dom";
import icons from "../../assets/images/sprite-other-icons.svg";

const PromotionsDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { offerData } = location.state || {};
  const topRef = useRef(null);

  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  const goBack = () => {
    navigate('/promotions');
  };

  const processHTML = (html) => {
    return html.replace(
      /<div class="SB-pageBackButton"[^>]*>.*?<\/div>/s,
      `<div class="SB-pageBackButton SB-iconSVG" onclick="return false;">
        <svg xmlns="http://www.w3.org/2000/svg">
          <use href="${icons}#icon-back" />
        </svg>
      </div>`
    );
  };

  return (
    <div>
      <div className="SB-page-content" ref={topRef}>
        {offerData?.offerdescription ? (
          <div
            dangerouslySetInnerHTML={{ 
              __html: processHTML(offerData.offerdescription) 
            }}
            onClick={(e) => {
              if (e.target.closest('.SB-pageBackButton')) {
                goBack();
              }
            }}
          />
        ) : (
          <div className="SB-promotions SB-promotion-detail">
            <div className="SB-promotion-item">
              <div className="SB-promotion-item-header">
                <BackArrow />
                <div className="SB-promotion-title">
                  No Offer Details Available
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PromotionsDetailPage;
